const PAGE_LIMIT = 10

// Helper functions
const getResultsFilteredBySearch = (job, search) => {
  const { department, location, team, title } = job

  let keywords = []
  keywords.push(title.toLowerCase())
  keywords.push(location.toLowerCase())
  if (team) {
    keywords.push(team.toLowerCase())
  }
  keywords.push(department.toLowerCase())
  keywords = keywords.join(' ')

  if (keywords.includes(search)) {
    return job
  }
}

const state = {
  careersData: [],
  currentResults: [],
  keyword: '',
  pageResults: []
}

const getters = {
  careersData: state => {
    return state.careersData
  },
  getCurrentResults: state => {
    return state.currentResults
  },
  getKeyword: state => {
    return state.keyword
  },
  getTotalNumOfCareers: (state, getters) => {
    return getters.careersData.length
  },
  getNumOfMatches: state => filter => {
    let array = state.careersData.filter(job => {
      const { department, location, team } = job

      if (location === filter || department === filter || team === filter) {
        return job
      }
    })

    return array.length
  },
  getNumOfResults: state => {
    return state.currentResults.length
  },
  getResults: (state, getters, rootState, rootGetters) => {
    let { careersData } = getters

    const departmentFilters = rootGetters['filters/getSelectedDepartments']
    const locationFilters = rootGetters['filters/getSelectedLocations']
    const teamFilters = rootGetters['filters/getSelectedTeams']
    const keyword = rootGetters['filters/getSearch']
    const pageNumber = rootGetters['pageNumber/getCurrent']
    const lowerPageLimit = (pageNumber - 1) * PAGE_LIMIT
    const upperPageLimit = PAGE_LIMIT * pageNumber

    const filterBySearch = keyword !== ''
    const filterByDepartment = departmentFilters.length > 0
    const filterByLocation = locationFilters.length > 0
    const filterByTeam = teamFilters.length > 0
    const filterBySelections = filterByDepartment || filterByLocation || filterByTeam

    if (!filterBySearch && !filterBySelections) {
      state.currentResults = careersData
      return careersData.slice(lowerPageLimit, upperPageLimit)
    }

    // Filters by keyword search
    if (filterBySearch) {
      careersData = careersData.filter(job => {
        return getResultsFilteredBySearch(job, keyword)
      })
    }

    // Filters by selected filters
    if (filterBySelections) {
      careersData = careersData.filter(result => {
        const { department, location, team } = result

        // Filter by department
        if (filterByDepartment && departmentFilters.includes(department) && !filterByLocation && !filterByTeam) {
          return result
        }

        // Filter by location
        if (filterByLocation && locationFilters.includes(location) && !filterByDepartment && !filterByTeam) {
          return result
        }

        // Filter by team
        if (filterByTeam && teamFilters.includes(team) && !filterByDepartment && !filterByLocation) {
          return result
        }

        // Filter by department and location
        if (filterByDepartment && departmentFilters.includes(department)
          && filterByLocation && locationFilters.includes(location) && !filterByTeam) {
          return result
        }

        // Filter by department and team
        if (filterByDepartment && departmentFilters.includes(department)
          && filterByTeam && teamFilters.includes(team) && !filterByLocation) {
          return result
        }

        // Filter by location and team
        if (filterByLocation && locationFilters.includes(location)
          && filterByTeam && teamFilters.includes(team) && !filterByDepartment) {
          return result
        }

        // Filter by department, location, and team
        if (filterByDepartment && departmentFilters.includes(department)
          && filterByLocation && locationFilters.includes(location)
          && filterByTeam && teamFilters.includes(team)) {
          return result
        }
      })
    }

    state.currentResults = careersData

    return state.currentResults.slice(lowerPageLimit, upperPageLimit)
  },
  getResultsByKeyword: (state, getters, rootState, rootGetters) => {
    const { careersData } = getters
    const { keyword } = state

    const pageNumber = rootGetters['pageNumber/getCurrent']
    const lowerPageLimit = (pageNumber - 1) * 10
    const upperPageLimit = PAGE_LIMIT * pageNumber

    if (keyword !== '') {
      state.currentResults = careersData.filter(job => {
        return getResultsFilteredBySearch(job, keyword)
      })
    }

    return state.currentResults.slice(lowerPageLimit, upperPageLimit)
  }
}

const mutations = {
  setCareersData (state, data) {
    state.careersData = data
  },
  setCurrentResults (state, results) {
    state.currentResults = results
  },
  setKeyword (state, keyword) {
    state.keyword = keyword
  },
  setPageResults (state, results) {
    state.pageResults = results
  }
}

export default {
  namespaced: true,
  state,
  getters,
  mutations
}
